module.exports = __webpack_public_path__ + "img/1534204563.4fc1128a.jpg";